import request from '@/utils/request';

export const getClientList = (data) => {
    return request({
        method: 'get',
        url: '/example-company',
        data
    })
}
// 案例详情 传 id 
export const getCaseDetail = (id) => {
    return request({
        method: 'get',
        url: `/example/${id}`,
    })
}

// 案例列表
export const example = (data) => {
    return request({
        method: 'get',
        url: `/example?example_companies_id=${data.example_companies_id}`
    })
}

//提交填写信息接口
export const getOurList = (data) => {
    return request({
        method: "post",
        url: "/custom-forms/ruhui",
        data,
    })
}

